import * as React from 'react';

const EmptyStar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={19} height={18} fill="none" viewBox="0 0 12 12" {...props}>
        <path
            fill="#fff"
            stroke="#6F6F6F"
            d="M6.313 9.671a1.25 1.25 0 0 0-1.292 0L2.81 11.006a.25.25 0 0 1-.373-.271l.587-2.515a1.25 1.25 0 0 0-.399-1.229L.671 5.298a.25.25 0 0 1 .142-.438l2.572-.218a1.25 1.25 0 0 0 1.045-.758L5.436 1.51a.25.25 0 0 1 .46 0l1.007 2.374c.181.427.583.719 1.045.758l2.572.218a.25.25 0 0 1 .142.438L8.708 6.991A1.25 1.25 0 0 0 8.31 8.22l.587 2.515a.25.25 0 0 1-.373.27z"
        />
    </svg>
);
export default EmptyStar;
